﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyTestDriveawayPrice", function () {
    var controller = [
      "$scope",
      function ($scope) {
        $scope.init = function () {
          $scope.driveawayPrice = $scope.driveawayPrice ? $scope.driveawayPrice : {};
          $scope.driveawayPrice.materialCode = "";
          $scope.driveawayPrice.usageTypeAvailable = "true";
          $scope.driveawayPrice.usageType = "";
        };

        $scope.init();
      },
    ];

    return {
      scope: false,
      restrict: "A",
      controller: controller,
      bindToController: true,
    };
  });
})(window.angular);
